import { PatientControllerApi } from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

type Params = {
  toEmail: string;
  fromEmail: string;
  subject: string;
  description: string;
  xTENANTID?: string;
  attachment?: File;
};

export const useSendEmailWithAttachment = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientControllerApi(getConfigObject()).sendEmailWithAttachment(
      params.toEmail,
      params.fromEmail,
      params.subject,
      params.description,
      params.xTENANTID,
      params.attachment
    )
  );
